export const GENDER_OPTIONS = [
  'Man (cisgender)',
  'Woman (cisgender)',
  'Agender',
  'Gender fluid',
  'Gender nonconforming',
  'Non-Binary',
  'Queer',
  'Trans man',
  'Trans woman',
  'Two-spirit',
  'Other',
  'Prefer Not To Say',
];

export const US_STATE_TERRITORY_CODES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY',
  'AA',
  'AE',
  'AP',
  'GU',
  'VI',
];

export const CA_PROVINCE_TERRITORY_CODES = [
  'AB',
  'BC',
  'MB',
  'NB',
  'NL',
  'NT',
  'NS',
  'NU',
  'ON',
  'PE',
  'QC',
  'SK',
  'YT',
];

export const OTHER_REGION_CODES = ['N/A'];

export function getGenderOptions() {
  return [...GENDER_OPTIONS];
}

export function getUsStateOptions() {
  return [...US_STATE_TERRITORY_CODES];
}

export function getCanadaProvinceOptions() {
  return [...CA_PROVINCE_TERRITORY_CODES];
}

export function getStateProvinceOptionsGrouped() {
  return [
    { label: '-US-', options: getUsStateOptions() },
    { label: '-CA-', options: getCanadaProvinceOptions() },
    { label: '-Other-', options: [...OTHER_REGION_CODES] },
  ];
}
